import { createFileRoute } from '@tanstack/react-router'

import { NnppOrdersPage } from '@/src/pages/nnpp/orders/NnppOrdersPage'

export const Route = createFileRoute('/nnpp/orders/')({
  component: NnppOrdersRoute,
  staticData: { layout: { enableScrolling: true, showSearchBar: false } },
})

function NnppOrdersRoute() {
  const { orgId } = Route.useSearch()
  return <NnppOrdersPage organizationId={orgId} />
}
